import { SelectV2 } from "@/modules/common/components";

import { FilterFieldRendererProps } from "../types";

const SelectFilterField = ({ field, value, onChange }: FilterFieldRendererProps) => {
  return (
    <SelectV2
      mode="single"
      align="start"
      placeholder={field.label}
      options={field.options ?? []}
      value={value !== undefined ? String(value) : undefined}
      onChange={(next) => {
        if (next === undefined) {
          onChange(undefined);
          return;
        }
        const parsed = field.schema.safeParse(next);
        onChange(parsed.success ? parsed.data : undefined);
      }}
    />
  );
};

export default SelectFilterField;
